import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '22px',
  },
  thumbnailWrapper: {
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '16px',
    padding: '11px 22px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
    backgroundColor: STYLE.COLOR.WHITE,
    boxShadow: '0px 4px 20px 0px rgba(0, 58, 87, 0.05)',
  },
  thumbnail: {
    display: 'block',
    width: '100%',
    height: '78px',
    objectFit: 'contain',
  },
  editLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    lineHeight: '14px',
  },
  editIcon: {
    width: '14px',
    height: '14px',
    flexShrink: 0,
  },
  saveButton: {
    minWidth: '204px !important',
  },
}));
